import { useSyncExternalStore } from 'react';

/**
 * 머리줄 「담당자」 고르기(2026-11-02 way 「모든 메뉴에 버스인 접수담당자 드롭다운」).
 *
 * 값 = 계정 id · 'none'(담당 미지정) · null(고르지 않음 = 계정 범위 그대로).
 * 모든 메뉴가 같은 값을 쓴다(정산년월처럼 화면마다 다시 고르지 않게 — issues 86). 계정에 기억한다(`owner.pick`).
 * `lib/api.ts` 가 목록 조회(`list…`)와 그 목록을 그대로 처리하는 일괄 쓰기에 `ownerPick` 으로 실어 보낸다.
 * 범위 강제는 서버(`shared.ts withPick`) — 계정 범위보다 넓어지지 않는다.
 */
export type OwnerPick = number | 'none' | null;

let value: OwnerPick = null;
const subs = new Set<() => void>();

export function getOwnerPick(): OwnerPick {
  return value;
}

export function setOwnerPick(v: OwnerPick): void {
  if (v === value) return;
  value = v;
  subs.forEach((f) => f());
}

export function isOwnerPick(v: unknown): v is OwnerPick {
  return v === null || v === 'none' || (typeof v === 'number' && Number.isInteger(v) && v > 0);
}

function subscribe(f: () => void): () => void {
  subs.add(f);
  return () => { subs.delete(f); };
}

/** 고르기가 바뀌면 다시 그린다 — 공용 목록 훅(`useList`)이 deps 에 넣어 다시 조회한다. */
export function useOwnerPick(): OwnerPick {
  return useSyncExternalStore(subscribe, getOwnerPick);
}
